export { default } from './src/loader';